import i18n from 'modules/core/lib/i18n'

import { ActivationCenterResourceType } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/enums'
import { UpsellExpensesButton } from 'modules/finance/components/FinancialWorkspace/components/UpsellExpenses'
import { FROM_AC_COMPONENT } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/lib/trackConst'

const SOURCE_ID = 'activation_center_expenses'

export const expenseResources = (available: boolean) => {
  const resources = {
    available: {
      label: i18n.t('finance.financial_workspace.activation_center.sources.expenses'),
      type: ActivationCenterResourceType.FILLED,
      sourceId: SOURCE_ID,
    },
    unavailable: {
      label: i18n.t('finance.financial_workspace.activation_center.sources.expenses'),
      type: ActivationCenterResourceType.NOT_ENABLED,
      button: UpsellExpensesButton({
        requestComponent: `${FROM_AC_COMPONENT}_expenses`,
        buttonTexts: {
          requested: i18n.t(
            'finance.financial_workspace.activation_center.expenses.button.requested'
          ),
          unlock: i18n.t('upselling_kit.button.more_info'),
        },
        pageSource: 'financial-workspace/employee-costs',
      }),
      sourceId: SOURCE_ID,
    },
  }

  return resources[available ? 'available' : 'unavailable']
}
